import script from "./involvedUsers.vue?vue&type=script&lang=ts&setup=true"
export * from "./involvedUsers.vue?vue&type=script&lang=ts&setup=true"

import "./involvedUsers.vue?vue&type=style&index=0&id=9988e7ac&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9988e7ac"]])

export default __exports__